import secureApi from '../../utils/secureApi';

export async function getWeeklyReport(id: string) {
  const response = await secureApi.get<any>(
    `/api/v2/tournaments/admin/weeklyReports/get-by-id?_id=${id}`
  );
  
  // secureApi returns response.data automatically
  // Handle API response structure: may be wrapped in { statusCode, data: {...} } or direct
  if (response && response._id) {
    return response; // Already the expected structure
  } else if (response && response.data && response.data._id) {
    return response.data; // Wrapped in data field
  }
  return response; // Fallback
} 